import { RESULT_STATUS, getErrorResult } from "./result";
import { isModuleRegistered } from "SharedStores/util";
import { PROJECT_TYPES, PROJECT_NAMESPACE } from "SharedStores/Project/projectStore";
import { HelperEvaluator } from "./helper";
import { EXPRESSION_CONSTANT } from "Formula/expressionTypes";

export class StringEvaluator extends HelperEvaluator {
    constructor(formulaEvaluator, storeContext) {
        super(formulaEvaluator, storeContext);
    }

    async stringEqualTo(exp) {
        const left = await this.evalString(exp.Children[0]);
        const right = await this.evalString(exp.Children[1]);

        const error = getErrorResult([left, right]);
        if (error) {
            return error;
        }
        const isIgnoreCase = exp.PropertyDictionary.ignoreCase === "true";
        let value = left.Value === right.Value;
        if (isIgnoreCase) {
            value = left.Value?.toUpperCase() === right.Value?.toUpperCase();
        }

        return { Value: value };
    }

    async stringNotEqualTo(exp) {
        const result = await this.stringEqualTo(exp);
        return this._negateResult(result);
    }

    evaluateStringConstant(exp) {
        return { Value: exp.StringConstantValue || "" };
    }

    evaluateStringDataReference(exp) {
        return this._evaluateStringDataReference(exp);
    }

    async evaluateConditionalString(exp) {
        const condition = await this.evalBool(exp.Children[0]);
        const left = await this.evalString(exp.Children[1]);
        const right = await this.evalString(exp.Children[2]);

        const error = getErrorResult([condition, left, right]);
        if (error) {
            return error;
        }

        const value = condition.Value ? left.Value : right.Value;

        return { Value: value };
    }

    async stringLength(exp) {
        const operand = await this.evalString(exp.Children[0]);
        const error = getErrorResult([operand]);
        if (error) {
            return error;
        }

        // TODO: really we should be trimming the value in evalString,
        // but we were concerned that that change could break existing behavior
        const value = operand.Value.trim().length;
        return { Value: value };
    }

    async evaluateConcatenateStrings(exp) {
        const left = await this.evalString(exp.Children[0]);
        const right = await this.evalString(exp.Children[1]);

        const error = getErrorResult([left, right]);
        if (error) {
            return error;
        }

        const value = left.Value + right.Value;
        return { Value: value };
    }

    evaluateProjectNumberReference(exp) {
        if (isModuleRegistered(PROJECT_NAMESPACE, this.state)) {
            const valStr = this.state[PROJECT_NAMESPACE].ProjectNumber;
            if (valStr) {
                return { Value: valStr };
            } else {
                const val = EXPRESSION_CONSTANT.UnsubmittedProjectNumberPlaceholder;
                return { Value: val };
            }
        }

        exp.inError = true;
        exp.errorMessage = "Project context not found to evaluate project number reference.";
        return { Status: RESULT_STATUS.Error, Message: exp.errorMessage };
    }

    evaluateDataFieldReferenceAsString(exp) {
        return this._evaluateStringDataReference(exp);
    }

    _evaluateStringDataReference(exp) {
        exp.usingDefault = false;

        if (isModuleRegistered(PROJECT_NAMESPACE, this.state)) {
            if (exp.PublicDataFieldDefinitionId) {
                let valStr = this.getters[PROJECT_TYPES.getters.dataFieldValueFromId](exp.PublicDataFieldDefinitionId);

                valStr = this._convertValueToString(exp, valStr);

                if (valStr) {
                    return { Value: valStr };
                } else {
                    // strings use an implicit default of string.Empty if the value
                    // returned from the data manager is not set or empty
                    exp.usingDefault = true;
                    const val = exp.StringConstantValue || "";
                    return { Value: val };
                }
            }
            exp.inError = true;
            exp.errorMessage = "No datafield reference specified.";
            return { Status: RESULT_STATUS.Error, Message: exp.errorMessage };
        }

        exp.inError = true;
        exp.errorMessage = "Project context not found to evaluate data field reference.";
        return { Status: RESULT_STATUS.Error, Message: exp.errorMessage };
    }
}
